import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { DIFICULT_RANGES, CIVILISATION_ID } from '../../app/constants'
import {
  GalaktikaMissionDifficulty,
  GalaktikaMissionDifficultyArrow,
} from '../../assets/img'
import { extractStake } from '../../utilities/extractStake'

export const MissionDifficultyIndex = ({ civilization, selected }) => {
  const epoch = useSelector((state) => state.epoch)
  const epochDetails = epoch.epochDetails
  const [difficulty, setDifficulty] = useState(0)

  const difficulties = {
    medium: '65deg',
    hard: '126deg',
    veryHard: '197deg',
    ultraHard: '290deg',
    easy: '2deg',
  }

  useEffect(() => {
    if (epochDetails.length > 0) {
      const filterEpoch = epochDetails.filter(
        (item) =>
          item.mission === selected.id &&
          item.civilization === CIVILISATION_ID[civilization],
      )
      console.log(filterEpoch)
      const leveOfStaking = filterEpoch[0]
        ? extractStake(filterEpoch[0].total_staked) /
          parseFloat(epoch.glkCirculatingSupply)
        : 0
      setDifficulty(Math.sqrt(Math.log(1 + leveOfStaking)) * 100)
    }
  }, [epoch])

  if (isNaN(difficulty)) {
    setDifficulty(0)
  }

  console.log('difficulty', difficulty)
  return (
    <>
      <h3 className="text-white  pt-7 xl:pt-10 3xl:pt-20">
        Mission Difficulty Index
      </h3>
      <div
        style={{ backgroundImage: `url(${GalaktikaMissionDifficulty})` }}
        className="bg-contain bg-no-repeat aspect-square relative mt-6 w-4/5 2xl:max-w-[20vw]"
      >
        <img
          style={
            difficulty <= DIFICULT_RANGES.easy
              ? { transform: `rotate(${difficulties.easy})` }
              : difficulty > DIFICULT_RANGES.easy &&
                difficulty <= DIFICULT_RANGES.medium
              ? { transform: `rotate(${difficulties.medium})` }
              : difficulty > DIFICULT_RANGES.medium &&
                difficulty <= DIFICULT_RANGES.hard
              ? { transform: `rotate(${difficulties.hard})` }
              : difficulty > DIFICULT_RANGES.hard &&
                difficulty <= DIFICULT_RANGES.veryHard
              ? { transform: `rotate(${difficulties.veryHard})` }
              : difficulty > DIFICULT_RANGES.veryHard
              ? { transform: `rotate(${difficulties.ultraHard})` }
              : ''
          }
          className="w-full aspect-square transition-transform duration-300"
          src={GalaktikaMissionDifficultyArrow}
          alt="Mission Difficulty Index Arrow"
        ></img>
      </div>
    </>
  )
}
